var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `src/translations`)
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { IntlProvider } from 'react-intl';
import { makeSelectLocale } from './selectors';
var LanguageProvider = /** @class */ (function (_super) {
    __extends(LanguageProvider, _super);
    function LanguageProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LanguageProvider.prototype.render = function () {
        return (_jsx(IntlProvider, __assign({ locale: this.props.locale, messages: this.props.messages[this.props.locale] }, { children: React.Children.only(this.props.children) }), this.props.locale));
    };
    return LanguageProvider;
}(React.PureComponent));
export { LanguageProvider };
LanguageProvider.propTypes = {
    locale: PropTypes.string,
    messages: PropTypes.object,
    children: PropTypes.element.isRequired,
};
var mapStateToProps = createSelector(makeSelectLocale(), function (locale) { return ({
    locale: locale,
}); });
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LanguageProvider);
